"use client";

import { useSyncExternalStore } from "react";

export interface WorkspaceToolStore<T extends string> {
  get: () => T | null;
  set: (tool: T | null) => void;
  toggle: (tool: T) => void;
  useTool: () => T | null;
}

export function createWorkspaceToolStore<T extends string>(): WorkspaceToolStore<T> {
  let activeTool: T | null = null;
  const listeners = new Set<() => void>();

  const emit = () => {
    for (const listener of listeners) listener();
  };

  const get = () => activeTool;

  const set = (tool: T | null) => {
    if (activeTool === tool) return;
    activeTool = tool;
    emit();
  };

  const toggle = (tool: T) => set(activeTool === tool ? null : tool);

  const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  };

  const useTool = () => useSyncExternalStore(subscribe, get, () => null);

  return { get, set, toggle, useTool };
}
